import { PublicationPublicPreview, PublicationsService } from "../client"

/* Interfaces & Types */
export type PublicationLayoutProps = {
    publications: PublicationPublicPreview[] | undefined
    isPending: boolean
    title: string
    category_img_path: string | null
    handleLoadMore: () => void
    isLoadingMore: boolean
    showMore: boolean
}


/* ENDPOINTS */
export const getPublications = ({category_id, skip} : {category_id: string, skip: number}) => {
    return {
        queryFn: async () => {
            const data = await PublicationsService.readPublicationsPublic({categoryId: category_id, skip: skip})
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["publications", { category_id, skip }],
    }
}

export const getPublicationByClassicId = (classic_id: number) => {
    return {
        queryFn: async () => {
            const data = await PublicationsService.readPublicationPublic({classicId: classic_id})
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["publication", { classic_id }],
    }
}
